import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
// import HeroSection from '../../components/HeroSection/HeroSection';
import UniversityPromotion from '../../components/UniversityPromotion/UniversityPromotion';
import Footer from '../../components/Footer/Footer';
import UniversityFooter from '../../components/UniversityFooter/UniversityFooter';
// import Sponsors from '../../components/Sponsors/Sponsors';
// import PromotionalBanner from '../../components/PromotionalBanner/PromotionalBanner';


const IntroPage = () => {
  return (
    <div>
      <Navbar />
      {/* <PromotionalBanner /> */}
      {/* <HeroSection /> */}
      <UniversityPromotion />
      {/* <Sponsors /> */}
      <UniversityFooter />
    </div>
  );
};

export default IntroPage;
